import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { debounce } from 'throttle-debounce';
import { toChunks, sleep, prependScript, createLogger, appendItem, getCookieItem } from './tools';
import { getTicketAndGroup } from '../service';
import { decorateAttachShadow, tagNameMap } from './common';
var keyTicket = 'ticket_data'; // const isDingTalk = /dingtalk/i.test(navigator.userAgent); // 浏览器端钉钉扫码登录 ua 不是 dingTalk
// const isDingTalk = true; // 浏览器打开二维码联登 钉钉扫码登录,  ua 不是 dingTalk

var openData = _extends({
  orgId: '',
  ready: false,
  // sdk就绪 可更新元素
  started: false,
  // 开始初始化
  corpId: '',
  // 企业在钉钉的企业id
  elements: [],
  // 待更新的 xx-open-data 元素列表
  XXOpenData: {}
}, createLogger('XXOpenData'), {
  addElement: function addElement(ele) {
    appendItem(this.elements, ele);
  },
  loadSDK: function loadSDK(lives, url) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var ok;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (lives === void 0) {
                lives = 3;
              }

              _context.next = 3;
              return prependScript(url);

            case 3:
              ok = _context.sent;
              _this.XXOpenData = window.XXOpenData; // debug

              _this.log('loading sdk lives:', lives);

              if (!(!ok && lives)) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return sleep(50);

            case 9:
              _context.next = 11;
              return _this.loadSDK(lives - 1, url);

            case 11:
              return _context.abrupt("return", _context.sent);

            case 12:
              return _context.abrupt("return", true);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  isReady: function isReady() {
    return this.ready;
  },
  isStarted: function isStarted() {
    return this.started;
  },

  /** 设置cookie 缓存 12h
   * @returns 
   */
  getTickets: function getTickets() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var hasTicket, old, d, ret, end, host;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              hasTicket = getCookieItem('ticket');
              _context2.prev = 1;
              old = localStorage.getItem(keyTicket);

              if (!(hasTicket && old)) {
                _context2.next = 6;
                break;
              }

              d = JSON.parse(old);
              return _context2.abrupt("return", d);

            case 6:
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

            case 10:
              _context2.next = 12;
              return getTicketAndGroup();

            case 12:
              ret = _context2.sent;
              localStorage.setItem(keyTicket, JSON.stringify(ret));
              end = new Date(); // 服务端过期时间约定为24h

              end.setHours(end.getHours() + 12);
              host = location.host;
              document.cookie = "ticket=" + (ret == null ? void 0 : ret.ticket) + ";expires=" + end.toUTCString() + ";path=/;domain=" + host.substring(host.indexOf('.')) + ";";
              return _context2.abrupt("return", ret);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }))();
  },
  init: function init(orgId) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var ticketRet, initDone, ctor, initOK;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _this2.started = true;
              _context3.next = 4;
              return _this2.getTickets();

            case 4:
              ticketRet = _context3.sent;
              _context3.next = 7;
              return _this2.loadSDK(undefined, ticketRet.domain + "/opendata-1.1.0.js");

            case 7:
              if (_this2.XXOpenData) {
                _context3.next = 11;
                break;
              }

              _this2.warn('load sdk fail, XXOpenData', _this2.XXOpenData);

              _this2.started = false;
              return _context3.abrupt("return");

            case 11:
              _this2.XXOpenData.initTimes = _this2.XXOpenData.initTimes || 0;
              _this2.XXOpenData.initTimes++;

              _this2.log('this.XXOpenData.initTimes', _this2.XXOpenData.initTimes);

              _this2.log('this.XXOpenData.initOK', _this2.XXOpenData.initOK);

              _this2.isMyAttachShadow = decorateAttachShadow();
              initDone = false;

              if (typeof customElements !== 'undefined' && typeof customElements.get === 'function') {
                // customElements.get() 不兼容ie
                ctor = customElements.get('xx-open-data');
                initDone = !!ctor;
              } else {
                // 其他业务模块都升级bi-h5后 可走到这里
                initDone = _this2.XXOpenData.initOK;
              }

              if (!initDone) {
                _context3.next = 22;
                break;
              }

              _this2.ready = true;
              setTimeout(function () {
                _this2.update(true);
              }, 100); // 等待所有open-data的mounted都执行 elements.push(this.$el)

              return _context3.abrupt("return");

            case 22:
              _context3.next = 24;
              return _this2.XXOpenData.init(_extends({
                baseUrl: ticketRet.domain
              }, ticketRet));

            case 24:
              initOK = _context3.sent;
              _this2.XXOpenData.initOK = initOK;

              if (!initOK) {
                _context3.next = 30;
                break;
              }

              _this2.ready = true; // 首次全量渲染，openid已传入时，会渲染得到名称；openid未传入时 则 open-data watch触发更新

              _this2.update();

              return _context3.abrupt("return");

            case 30:
              throw new Error("open data init error initOK=" + initOK);

            case 33:
              _context3.prev = 33;
              _context3.t0 = _context3["catch"](0);
              _this2.started = false;
              console.error(_context3.t0);

            case 37:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 33]]);
    }))();
  },
  update: function update(isAll) {
    if (isAll === void 0) {
      isAll = false;
    }

    if (!this.XXOpenData.initOK) {
      console.warn('XXOpenData 还没有初始');
      return;
    } // 1、调用XXOpenData.update方法前，一定要确保 XXOpenData.init 方法已经调用成功，否则update方法无法生效。
    // 2、XXOpenData.update方法一次性传入的dom节点数量不可以超过200个，否则无法正常渲染。


    var cloneEleList;

    if (isAll || this.elements.length === 0) {
      cloneEleList = Array.from(document.querySelectorAll('xx-open-data'));
    } else {
      cloneEleList = this.elements.slice();
    }

    if (cloneEleList.length === 0) {
      return;
    }

    this.elements = []; // 清空

    var openDataEleChunks = toChunks(cloneEleList, 150); // 分块 使每次更新元素个数小于200

    openDataEleChunks.forEach(function (chunk, i) {
      setTimeout(function () {
        window.XXOpenData && window.XXOpenData.update(chunk);
      }, i * 40);
    });
  },
  debUpdate: function debUpdate(ele) {
    if (ele) {
      var tagName = tagNameMap.abookcrypto[0];
      ele.tagName.toUpperCase() === tagName.toUpperCase() && this.addElement(ele);
    }

    this._debUpdate(false);
  },
  _debUpdate: debounce(80, function (bool) {
    if (bool === void 0) {
      bool = true;
    }

    openData.update(bool);
  }),
  tag: function tag(shortType, openid) {
    var typeMap = {
      user: 'userName',
      dept: 'deptName'
    };
    var type = typeMap[shortType];
    var tagName = tagNameMap.abookcrypto[0];
    var idName = tagNameMap.abookcrypto[1];
    var typeName = tagNameMap.abookcrypto[2];
    return "<" + tagName + " " + typeName + "=\"" + type + "\" " + idName + "=\"" + openid + "\" ></" + tagName + ">";
  }
});

export default {
  openData: openData
};